/*
 * @Author: your name
 * @Date: 2021-03-12 14:10:03
 * @LastEditTime: 2021-03-26 09:04:37
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \vue3-element-admin\src\directives\modules\permission.js
 */

const role = (el, binding, app, router, store) => {
    const { value } = binding;
    function check(roleId) {
        if(roleId == store.getters.userinfo.roleId){
            return true;
        }
        return false;
    }

    function checkRoles(roles) {
        // 如果传入的是数组，检查用户角色是否在数组中
        if (Array.isArray(roles)) {
            return roles.some(roleId => check(roleId));
        }
        // 如果传入的是单个值，使用原有逻辑
        return check(roles);
    }

    if (value) {
        let hasRole = checkRoles(value);
        if (!hasRole) {
            // 没有权限 移除Dom元素
            el.parentNode && el.parentNode.removeChild(el);
        }
    }
};

export default role;
